import { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allParkingbay, deleteParkingBay } from "../../redux/actions/parkingbay";
import { showNotification } from "../../redux/actions/notification";
import { Button } from "antd";
import { Popover, Badge } from "antd";
import CustomModal from "../../common/CustomModal";
import CustomTable from "../../common/CustomTable";
import AddAmbulanceToParkingBay from "./addAmbulanceToParingBay";
import { ambulanceParkingbayMapping } from "../../apis/mapping";
import EditParkingBayForm from "./EditParkingBayForm";
import ParkingBayFilters from "./parkingBayFilters";

function AllParkingBay() {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [message, setMessage] = useState({ info: "", errorMsg: "" });
  const [filters, setFilters] = useState({})

  const { object = [], totalCount = 0, isProcessing: isLoading } = useSelector(
    (state) => state.parkingbay?.data
  );
  
  useEffect(() => {
    setPagination((prev) => ({ ...prev, total: totalCount }));
  }, [totalCount]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };
  
  const handlePageSizeChange = (size) => {
    setPagination({ page: 1, pageSize: size, total: pagination.total });
  };

  const handleEditParkingBay = (record) => {
    setSelectedRowDetails(record);
    setIsModalVisible(true);
  }

  const handleAddAmbulance = useCallback((record) => {
    setSelectedRowDetails(record);
    setIsModalVisible(true);
  }, []);
  const handleDeleteParkingBay = (id) => {
    dispatch(deleteParkingBay(id))
  }
  useEffect(() => {
    const query = {
      page: pagination.page -1,
      pageSize: pagination.pageSize,
      ...filters,
    };
    dispatch(allParkingbay(query));
  }, [dispatch, pagination.page, pagination.pageSize, filters]);  
  
  // const handleSave = useCallback((query) => {
  //   ambulanceParkingbayMapping(query)
  //     .then(() => {
  //       setMessage({ info: "Ambulance successfully added!", errorMsg: "" });
  //       setIsModalVisible(false);
  //       dispatch(showNotification({
  //         type: 'success',
  //         message: 'Success',
  //         description: 'Ambulance Mapped Successfully',
  //       }));
  //     })
  //     .catch((err) => {
  //       setMessage({ info: "", errorMsg: "Failed to add ambulance." });
  //       dispatch(showNotification({
  //         type: 'error',
  //         message: 'Unable to Add',
  //         description: err,
  //       }))
  //     });
  // }, [dispatch]);

  function handleEditParkingBaySave() {

  }

  const columns = useMemo(
    () => [
      { title: "ID", dataIndex: "parkingBayLocationId" },
      { title: "Name", dataIndex: "parkingBayName" },
      { title: "Latitude", dataIndex: "latitude" },
      { title: "Longitude", dataIndex: "longitude" },
      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              type="primary"
              size="small"
              onClick={() => handleEditParkingBay(record)}
            >
              Edit
            </Button>
            <Button
              danger
              size="small"
              onClick={() => handleDeleteParkingBay(record.parkingBayLocationId)}
            >
              Delete
            </Button>
          </div>
        ),
      }
      // {
      //   title: "Mapped Ambulances",
      //   key: "mappedAmbulances",
      //   render: (_, record) => {
      //     const ambulances = record.ambulances || [];
      //     if (!ambulances.length) {
      //       return <span style={{ color: "gray" }}>No ambulances mapped</span>;
      //     }
      
      //     const content = (
      //       <ul style={{ margin: 0, paddingLeft: 20, maxHeight: 200, overflowY: 'auto' }}>
      //         {ambulances.map((item) => (
      //           <li key={item.ambulanceId}>
      //             <strong>{item.ambulanceCode}</strong> - {item.ambulanceNumber}
      //           </li>
      //         ))}
      //       </ul>
      //     );
      
      //     return (
      //       <Popover content={content} title="Mapped Ambulances" trigger="click">
      //         <Badge count={ambulances.length} style={{ backgroundColor: '#52c41a' }}>
      //           <Button size="small" type="link">
      //             View Ambulances
      //           </Button>
      //         </Badge>
      //       </Popover>
      //     );
      //   }
      // },
      // {
      //   title: "Action",
      //   key: "action",
      //   render: (_, record) => (
      //     <>
      //       <Button type="primary" onClick={() => handleAddAmbulance(record)}>Add Ambulance</Button>
      //       <Button type="primary" danger onClick={() => handleDeleteParkingBay(record.id)}>Delete</Button>
      //     </>
      //   ),
      // },
    ],
    [handleAddAmbulance]
  );

  return (
    <div>
      <h1>All Master Location List</h1>
      {/* <ParkingBayFilters
        onFilter={(filters) => {
          setPagination((prev) => ({ ...prev, page: 1 }));
          setFilters(filters);
        }}
      /> */}
      {isLoading && <p>Loading...</p>}
      
      {object.length > 0 ? (
        <CustomTable
          columns={columns}
          data={object}
          loading={isLoading}
          pagination={pagination}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      ) : (
        <p>No Master Location Found</p>
      )}

      {isModalVisible && selectedRowDetails && (
        <CustomModal
          visible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          title="Add Ambulances To the Parking Bay"
          content={
            // <AddAmbulanceToParkingBay 
            //   selectedParkingBayDetails={selectedRowDetails}
            //   onSubmit={handleSave}
            //   successMsg={message.info}
            //   errorMsg={message.errorMsg}
            // />
            <EditParkingBayForm />
          }
          isEditable={false}
        />
      )}
    </div>
  );
}

export default AllParkingBay;
